import CreditLimits from './CreditLimits';

export default CreditLimits;